import { varietyState } from '@/app/model/store/domain/types'

export default <varietyState> {
  orderNum: 1,
  sort: 'asc',
  searchText: ''
}
